module.exports = __webpack_public_path__ + "static/media/iolabs-logo.24a9795e.png";